var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrecipitationIntensity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    style: {
      transform: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.527 16.615a.986.986 0 00-.81.418c-.554.785-1.19 1.877-1.19 2.755 0 1.222.896 2.212 2 2.212s2-.99 2-2.212c0-.878-.635-1.97-1.189-2.755a.987.987 0 00-.81-.418M18.5 10.17c1.093 1.526 1.5 2.621 1.5 3.143 0 .93-.673 1.687-1.5 1.687s-1.5-.757-1.5-1.687c0-.522.408-1.617 1.5-3.143m0-2.64a.996.996 0 00-.777.37C16.69 9.161 15 11.507 15 13.312 15 15.35 16.567 17 18.5 17c1.934 0 3.5-1.65 3.5-3.687 0-1.805-1.69-4.15-2.722-5.414a1 1 0 00-.778-.37M7.027 5.06c1.87 2.344 3 4.502 3 5.78 0 1.742-1.346 3.16-3 3.16s-3-1.418-3-3.16c0-1.278 1.131-3.436 3-5.78m0-2.568a.99.99 0 00-.753.345C4.878 4.454 2.027 8.094 2.027 10.84c0 2.85 2.24 5.161 5 5.161 2.762 0 5-2.31 5-5.16 0-2.746-2.85-6.386-4.247-8.003a.99.99 0 00-.753-.345"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecipitationIntensity);
export default __webpack_public_path__ + "static/media/precipitation-intensity.7cfa2ad8da4aa56ebef13a2b86cf1d48.svg";
export { ForwardRef as ReactComponent };